export const mockData: any = {
  dashboard: [
    {
      prefix: "",
      count: 500,
      suffix: "+",
      value: "Business Proposals",
    },
    {
      prefix: "",
      count: 47,
      suffix: "+",
      value: "Solar Projects",
    },
    {
      prefix: "$",
      count: 95,
      suffix: "BN",
      value: "Funding",
    },
    {
      prefix: "",
      count: undefined,
      suffix: "",
      value: "",
    },
    {
      prefix: "$",
      count: 95,
      suffix: "TN",
      value: "Investment Needed",
    },
    {
      prefix: "$",
      count: 15,
      suffix: "TN",
      value: "Investment Gap",
    },
    {
      prefix: "",
      count: 100,
      suffix: "+",
      value: "New Technologies Innovation",
    },
  ],
  investment: [
    {
      content:
        "I-bonds are over, long live I-bonds: This is your warning that rates are about to drop under 4%.",
      code: "IANS",
      time: "25 Minutes Ago",
      link: "https://www.marketwatch.com/story/i-bonds-are-over-long-live-i-bonds-this-is-your-warning-that-rates-are-about-to-drop-precipitously-cba31ac1",
    },
    {
      content: "What falling interest rates could mean for stock markets",
      code: "ATP",
      time: "1 Day Ago",
      link: "https://uk.finance.yahoo.com/news/falling-interest-rates-could-mean-080930771.html?guccounter=1&guce_referrer=aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20v&guce_referrer_sig=AQAAAL_ZD54TsxXjtPQ0OQKXC8F4w2OIRuwAvouuAvW1PtgWW3MHKFkBeUEnxUrKdZqPr1dItLD6Kwrl3TjBSB07CtLrOAqY6oQAak21N1AGLBwKkybOXonFkvWJ9SZzFGWa07RoUvd2eQmWA21Y4xJwk0eNqTZQUnAApEB6siTN0Olf",
    },
    {
      content:
        "1 chart: Fed's smaller interest rate hikes may be good news for housing market",
      code: "IANS",
      time: "3 Days Ago",
      link: "https://www.usatoday.com/story/graphics/2023/03/21/february-home-sales-prices/11514793002/",
    },
    {
      content: "A Fed Interest Rate Decrease by Summer? ",
      code: "Tech Brain",
      time: "6 Days Ago",
      link: "https://www.floridarealtors.org/news-media/news-articles/2023/03/fed-interest-rate-decrease-summer",
    },
  ],
  marketplace: [
    {
      content: "Weakening LNG prices spur renewed spot demand in South Asia",
      code: "IANS",
      time: "25 Minutes Ago",
      link: "https://www.spglobal.com/commodityinsights/en/market-insights/latest-news/lng/021623-weakening-lng-prices-spur-renewed-spot-demand-in-south-asia",
    },
    {
      content: "Asian spot prices remain at 21-month low",
      code: "ATP",
      time: "1 Day Ago",
      link: "https://www.reuters.com/business/energy/asian-spot-prices-remain-21-month-low-2023-04-06/",
    },
    {
      content:
        "LNG prices keep sliding, but energy crisis far from over with supply outlook tight: Experts",
      code: "IANS",
      time: "3 Days Ago",
      link: "https://www.straitstimes.com/business/lng-prices-keep-sliding-but-energy-crisis-far-from-over-with-supply-outlook-tight-experts",
    },
    {
      content: "ASIAN SPOT LNG PRICES HIT 19-MONTH LOW ON TEPID DEMAND",
      code: "Tech Brain",
      time: "6 Days Ago",
      link: "https://www.naturalgasworld.com/asian-spot-lng-prices-slump-to-19-month-low-on-weak-demand-103990",
    },
  ],
  esg: [
    {
      content:
        "Revealed: How Shell cashed in on dubious carbon offsets from Chinese rice paddies",
      code: "IANS",
      time: "25 Minutes Ago",
      link: "https://www.climatechangenews.com/2023/03/28/revealed-how-shell-cashed-in-on-dubious-carbon-offsets-from-chinese-rice-paddies/",
    },
    {
      content: "Shell rules out more ambitious goal for end-user emissions",
      code: "ATP",
      time: "1 Day Ago",
      link: "https://www.reuters.com/business/environment/shell-rules-out-more-ambitious-goal-end-user-emissions-2023-03-16/",
    },
    {
      content:
        "Can you future-proof a refinery against climate change concerns? Shell thinks so",
      code: "IANS",
      time: "3 Days Ago",
      link: "https://www.cbc.ca/news/canada/calgary/bakx-shell-scotford-climate-1.6814058",
    },
    {
      content:
        "HIGHLIGHTS: Turning Waste to Fuel with Pfizer, Shell & Exxon: ESGL in Fireside Chat",
      code: "Tech Brain",
      time: "6 Days Ago",
      link: "https://finance.yahoo.com/news/highlights-turning-waste-fuel-pfizer-183640205.html?guccounter=1&guce_referrer=aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20v&guce_referrer_sig=AQAAAHlaA8ZgVt78e66wTfKalUERoLHilrDXXBG5OQjbjQtIddiicxwbdbmqE7J6za7GEv6njhFXCKsBPPxpC-rKzkqyS4wS1gn90kT77rpux-Eig5qezw2DEpEqHT1SR0WOuDXq7jlKD803ScnXEgrDlwKBTKNz-R6MX8nq7qrOFMnh",
    },
  ],
};
